import type { ReactNode } from 'react'
import type { SvgIconSize } from 'LuxKit/SvgIcon'
import SolidCarIcon from 'LuxKit/Icons/solid/SolidCarIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import LineBusIcon from 'LuxKit/Icons/line/LineBusIcon'
import LineSubwayIcon from 'LuxKit/Icons/line/LineSubwayIcon'
import LineShipIcon from 'LuxKit/Icons/line/LineShipIcon'
import LineCarIcon from 'LuxKit/Icons/line/LineCarIcon'

export function getTransportIcon(type: string, size: SvgIconSize = 'M'): ReactNode {
  const normalised = type.toLowerCase().replace(/[_\s]/g, '')
  switch (normalised) {
    case 'flight':
    case 'leflight':
    case 'chatflight':
      return <LinePlaneDepartureIcon size={size} />
    case 'driving':
    case 'drive':
    case 'car':
    case 'carrental':
      return <SolidCarIcon size={size} />
    case 'publictransport':
    case 'transit':
    case 'bus':
      return <LineBusIcon size={size} />
    case 'train':
      return <LineSubwayIcon size={size} />
    case 'ferry':
    case 'cruise':
    case 'lecruise':
      return <LineShipIcon size={size} />
    default:
      return <LineCarIcon size={size} />
  }
}
